import { render, staticRenderFns } from "./compElCheckboxGroup.vue?vue&type=template&id=485121d9&scoped=true&"
import script from "./compElCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./compElCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./compElCheckboxGroup.vue?vue&type=style&index=0&id=485121d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485121d9",
  null
  
)

export default component.exports